import { render, staticRenderFns } from "./AppHeaderNavMoreSocial.vue?vue&type=template&id=4d20f702&"
import script from "./AppHeaderNavMoreSocial.vue?vue&type=script&lang=js&"
export * from "./AppHeaderNavMoreSocial.vue?vue&type=script&lang=js&"
import style0 from "./AppHeaderNavMoreSocial.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports